import * as React from "react";

class DeleteIcon extends React.Component<{}, {}, {}> {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <g fill="none" fillRule="evenodd">
                    <circle cx="20" cy="20" r="20" fill="#E40514" />
                    <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M25.786 30.571c1.064 0 1.928-.864 1.928-1.928v-13.5h.643c.355 0 .643-.288.643-.643v-.643c0-.355-.288-.643-.643-.643h-3.311l-1.366-2.278c-.284-.474-.93-.865-1.5-.927L22.025 10h-4.05c-.603 0-1.344.42-1.654.936l-1.367 2.278h-3.311c-.355 0-.643.288-.643.643v.643c0 .355.288.643.643.643h.643v13.5c0 1.064.864 1.928 1.928 1.928h11.572zm-2.99-17.357h-5.593l.701-1.169c.03-.048.089-.09.148-.107l.06-.01h3.777c.075 0 .168.053.206.117l.702 1.17zm2.99 15.429H14.214v-13.5h11.572v13.5zm-3.054-1.929c.266 0 .482-.216.482-.482v-8.678c0-.267-.216-.483-.482-.483h-.964c-.266 0-.482.216-.482.483v8.678c0 .266.216.482.482.482h.964zm-4.5 0c.266 0 .482-.216.482-.482v-8.678c0-.267-.216-.483-.482-.483h-.964c-.266 0-.482.216-.482.483v8.678c0 .266.216.482.482.482h.964z"
                    />
                </g>
            </svg>
        );
    }
}

export default DeleteIcon;
